import Jsona from 'jsona';
import KebabJsonPropertiesMapper from '@/lib/jsona/kebab-json-properties-mapper';

export default new Jsona({
  jsonPropertiesMapper: new KebabJsonPropertiesMapper()
});
